var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g2, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g3, _path107, _path108, _g4, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g5, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _g6, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsFaq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.324 30.6005C114.999 20.699 99.6555 28.8505 91.98 37.5305C84.3045 46.2105 78.5855 54.9779 68.95 56.5879C59.3145 58.1979 44.695 54.1134 33.803 61.7854C22.911 69.4574 22.953 89.8344 31.577 101.388C40.201 112.941 62.5135 118.464 88.256 122.178C97.4929 123.577 106.919 123.054 115.944 120.641L127.638 116.396C133.35 113.788 138.138 110.852 142.191 108.468C148.358 104.828 150.531 95.9559 151.711 89.4565C153.423 79.7168 153.275 69.7409 151.273 60.0564C148.69 47.8554 142.8 36.582 132.324 30.6005Z",
    fill: "#0094DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M132.324 30.6005C114.999 20.699 99.6555 28.8505 91.98 37.5305C84.3045 46.2105 78.5855 54.9779 68.95 56.5879C59.3145 58.1979 44.695 54.1134 33.803 61.7854C22.911 69.4574 22.953 89.8344 31.577 101.388C40.201 112.941 62.5135 118.464 88.256 122.178C97.4929 123.577 106.919 123.054 115.944 120.641L127.638 116.396C133.35 113.788 138.138 110.852 142.191 108.468C148.358 104.828 150.531 95.9559 151.711 89.4565C153.423 79.7168 153.275 69.7409 151.273 60.0564C148.69 47.8554 142.8 36.582 132.324 30.6005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M158.809 42.7281C158.417 36.2601 154 34.1391 151.2 37.2191C150.535 37.9704 150.089 38.8904 149.912 39.8781C149.735 40.8659 149.833 41.8834 150.195 42.8191C151.179 45.4756 152.869 50.1901 153.877 53.8791C155.361 59.3251 154.864 63.5321 156.597 61.3061C158.329 59.0801 159.302 50.8971 158.809 42.7281Z",
    fill: "#0094DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M158.809 42.7281C158.417 36.2601 154 34.1391 151.2 37.2191C150.535 37.9704 150.089 38.8904 149.912 39.8781C149.735 40.8659 149.833 41.8834 150.195 42.8191C151.179 45.4756 152.869 50.1901 153.877 53.8791C155.361 59.3251 154.864 63.5321 156.597 61.3061C158.329 59.0801 159.302 50.8971 158.809 42.7281Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.063 41.7375C86.7825 41.244 90.2475 34.8075 94.703 32.0845C99.1585 29.3615 95.2 27.3805 91 29.3615C91 29.3615 87.78 30.1035 85.3055 35.056C82.831 40.0085 81.34 42.231 84.063 41.7375Z",
    fill: "#0094DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M84.063 41.7375C86.7825 41.244 90.2475 34.8075 94.703 32.0845C99.1585 29.3615 95.2 27.3805 91 29.3615C91 29.3615 87.78 30.1035 85.3055 35.056C82.831 40.0085 81.34 42.231 84.063 41.7375Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6075 38.2728C81.816 37.3873 84.224 31.3743 81.7075 31.6823C81.3895 31.7284 81.0888 31.8557 80.8344 32.0519C80.58 32.2481 80.3804 32.5065 80.255 32.8023C79.45 34.5908 77.6195 39.0673 79.6075 38.2728Z",
    fill: "#0094DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M79.6075 38.2728C81.816 37.3873 84.224 31.3743 81.7075 31.6823C81.3895 31.7284 81.0888 31.8557 80.8344 32.0519C80.58 32.2481 80.3804 32.5065 80.255 32.8023C79.45 34.5908 77.6195 39.0673 79.6075 38.2728Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.093 150.216C132.201 150.216 163.905 149.038 163.905 147.584C163.905 146.131 132.201 144.952 93.093 144.952C53.9846 144.952 22.281 146.131 22.281 147.584C22.281 149.038 53.9846 150.216 93.093 150.216Z",
    fill: "#0094DE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M93.093 150.216C132.201 150.216 163.905 149.038 163.905 147.584C163.905 146.131 132.201 144.952 93.093 144.952C53.9846 144.952 22.281 146.131 22.281 147.584C22.281 149.038 53.9846 150.216 93.093 150.216Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M127.127 48.6504C126.988 48.6504 126.854 48.7057 126.756 48.8042C126.657 48.9026 126.602 49.0362 126.602 49.1754V51.8669H117.008V49.1754C117.008 49.0362 116.953 48.9026 116.855 48.8042C116.756 48.7057 116.623 48.6504 116.483 48.6504C116.344 48.6504 116.211 48.7057 116.112 48.8042C116.014 48.9026 115.958 49.0362 115.958 49.1754V116.97C115.958 117.11 116.014 117.243 116.112 117.342C116.211 117.44 116.344 117.495 116.483 117.495C116.623 117.495 116.756 117.44 116.855 117.342C116.953 117.243 117.008 117.11 117.008 116.97V101.805H126.602V116.97C126.602 117.11 126.657 117.243 126.756 117.342C126.854 117.44 126.988 117.495 127.127 117.495C127.266 117.495 127.4 117.44 127.498 117.342C127.597 117.243 127.652 117.11 127.652 116.97V49.1649C127.649 49.0275 127.593 48.8966 127.495 48.8004C127.396 48.7042 127.264 48.6504 127.127 48.6504ZM126.602 100.765H117.008V97.3634H126.602V100.765ZM126.602 96.3099H117.008V92.9114H126.602V96.3099ZM126.602 91.8579H117.008V88.4699H126.602V91.8579ZM126.602 87.4094H117.008V84.0354H126.602V87.4094ZM126.602 82.9644H117.008V79.6289H126.602V82.9644ZM126.602 78.5334H117.008V75.1769H126.602V78.5334ZM126.602 74.1234H117.008V70.7354H126.602V74.1234ZM126.602 69.6714H117.008V66.2834H126.602V69.6714ZM126.602 65.2299H117.008V61.8314H126.602V65.2299ZM126.602 60.7779H117.008V57.3724H126.602V60.7779ZM126.602 56.3224H117.008V52.9169H126.602V56.3224Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.253 103.306C36.253 103.306 44.1105 92.5505 40.278 90.006C36.2915 87.3775 34.419 95.34 33.5755 99.2495C31.7765 107.593 32.284 109.365 33.4915 107.531L36.253 103.306Z",
    fill: "#0094DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.253 103.306C36.253 103.306 44.1105 92.5505 40.278 90.006C36.2915 87.3775 34.419 95.34 33.5755 99.2495C31.7765 107.593 32.284 109.365 33.4915 107.531L36.253 103.306Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 109.921C39.2 109.921 50.1235 102.298 47.32 98.6648C44.4045 94.8813 40.047 101.815 37.9785 105.231C33.565 112.539 33.474 114.38 35.21 113.036L39.2 109.921Z",
    fill: "#0094DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.2 109.921C39.2 109.921 50.1235 102.298 47.32 98.6648C44.4045 94.8813 40.047 101.815 37.9785 105.231C33.565 112.539 33.474 114.38 35.21 113.036L39.2 109.921Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.438 118.762C39.438 118.762 48.888 114.516 47.2745 111.331C45.5945 108.017 41.258 112.679 39.1825 114.996C34.748 119.945 34.412 121.338 35.9345 120.564L39.438 118.762Z",
    fill: "#0094DE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.438 118.762C39.438 118.762 48.888 114.516 47.2745 111.331C45.5945 108.017 41.258 112.679 39.1825 114.996C34.748 119.945 34.412 121.338 35.9345 120.564L39.438 118.762Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.998 127.642C39.998 127.642 49.448 123.397 47.838 120.212C46.1545 116.901 41.8215 121.559 39.7425 123.88C35.3115 128.829 34.972 130.222 36.498 129.445L39.998 127.642Z",
    fill: "#0094DE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.998 127.642C39.998 127.642 49.448 123.397 47.838 120.212C46.1545 116.901 41.8215 121.559 39.7425 123.88C35.3115 128.829 34.972 130.222 36.498 129.445L39.998 127.642Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9135 107.8C28.9135 107.8 18.5255 99.4599 15.827 103.17C13.027 107.02 20.888 109.27 24.7555 110.292C33.0085 112.473 34.8005 112.042 33.0225 110.754L28.9135 107.8Z",
    fill: "#0094DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.9135 107.8C28.9135 107.8 18.5255 99.4599 15.827 103.17C13.027 107.02 20.888 109.27 24.7555 110.292C33.0085 112.473 34.8005 112.042 33.0225 110.754L28.9135 107.8Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2215 114.769C29.2215 114.769 17.3845 108.658 15.477 112.834C13.4925 117.177 21.6475 117.807 25.627 118.038C34.1495 118.535 35.8225 117.758 33.824 116.848L29.2215 114.769Z",
    fill: "#0094DE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.2215 114.769C29.2215 114.769 17.3845 108.658 15.477 112.834C13.4925 117.177 21.6475 117.807 25.627 118.038C34.1495 118.535 35.8225 117.758 33.824 116.848L29.2215 114.769Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.653 122.581C30.653 122.581 20.503 117.681 18.9875 121.261C17.409 124.982 24.318 125.325 27.7025 125.426C34.9195 125.65 36.316 124.95 34.6045 124.25L30.653 122.581Z",
    fill: "#0094DE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.653 122.581C30.653 122.581 20.503 117.681 18.9875 121.261C17.409 124.982 24.318 125.325 27.7025 125.426C34.9195 125.65 36.316 124.95 34.6045 124.25L30.653 122.581Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.15 128.891C31.15 128.891 21.574 122.941 19.6875 126.34C17.724 129.871 24.5595 130.946 27.9125 131.408C35.0665 132.395 36.526 131.852 34.9125 130.953L31.15 128.891Z",
    fill: "#0094DE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.15 128.891C31.15 128.891 21.574 122.941 19.6875 126.34C17.724 129.871 24.5595 130.946 27.9125 131.408C35.0665 132.395 36.526 131.852 34.9125 130.953L31.15 128.891Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2435 97.2337C30.2435 97.2337 28.4445 81.6132 22.5435 83.2092C16.415 84.8752 21.546 92.7782 24.15 96.6002C29.6835 104.734 31.7205 105.63 31.283 103.089L30.2435 97.2337Z",
    fill: "#0094DE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.2435 97.2337C30.2435 97.2337 28.4445 81.6132 22.5435 83.2092C16.415 84.8752 21.546 92.7782 24.15 96.6002C29.6835 104.734 31.7205 105.63 31.283 103.089L30.2435 97.2337Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.751 88.9004C23.751 88.9004 32.732 105.728 34.125 113.54C35.728 122.514 35.987 132.538 34.881 140.392",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7075 108.343L37.107 94.8682",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 113.54L42.406 103.128",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5965 111.647L21.6055 106.61",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1645 120.593L44.1805 113.684",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.685 117.628L25.2665 115.668",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1365 124.842L27.8425 123.687",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7525 129.51L40.6595 125.114",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6545 131.488L27.272 129.381",
    stroke: "#0094DE",
    strokeWidth: 1.25197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4455 134.054H39.354V136.105H38.4895L36.701 147.294H32.0985L30.31 136.105H29.4455V134.054Z",
    fill: "#0094DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.4455 134.054H39.354V136.105H38.4895L36.701 147.294H32.0985L30.31 136.105H29.4455V134.054Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7625 28.3919C45.3329 28.008 44.8083 27.7462 44.2433 27.6336C43.6783 27.5209 43.0935 27.5616 42.5495 27.7514C40.6245 28.3919 38.78 31.1744 39.2455 33.5299C39.571 35.1609 41.083 37.5654 41.5415 38.4824C42 39.3994 41.356 40.9499 39.9 44.1699C38.444 47.3899 37.8805 50.4104 42.1015 53.0704C46.3225 55.7304 51.1 51.5094 53.55 48.4819C56 45.4544 51.7125 38.4824 51.345 35.5319C50.9775 32.5814 50.3475 26.9254 45.7625 28.3919Z",
    fill: "#0D3744"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.685 48.6846C54.6347 49.7354 53.3657 50.5418 51.9682 51.0463C50.5708 51.5508 49.0793 51.7411 47.6 51.6036L46.5885 55.8211L48.5135 65.4496L61.082 58.9361L58.2365 51.5861L55.685 48.6846Z",
    fill: "#0094DE",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.685 48.6846C54.6347 49.7354 53.3657 50.5418 51.9682 51.0463C50.5708 51.5508 49.0793 51.7411 47.6 51.6036L46.5885 55.8211L48.5135 65.4496L61.082 58.9361L58.2365 51.5861L55.685 48.6846Z",
    fill: "#0D3744"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.685 48.6847L53.76 35.9307L48.055 37.0997L45.2095 38.9337C45.2095 38.9337 41.8145 41.5972 41.8145 41.8702C41.8145 42.1432 47.558 51.7542 47.558 51.7542C49.0523 51.8426 50.5485 51.6149 51.9488 51.086C53.3492 50.5571 54.6223 49.7389 55.685 48.6847Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.685 48.6847L53.76 35.9307L48.055 37.0997L45.2095 38.9337C45.2095 38.9337 41.8145 41.5972 41.8145 41.8702C41.8145 42.1432 47.558 51.7542 47.558 51.7542C49.0523 51.8426 50.5485 51.6149 51.9488 51.086C53.3492 50.5571 54.6223 49.7389 55.685 48.6847Z",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.0305 48.1391C48.0305 48.1391 52.052 45.1571 51.681 46.0391C51.31 46.9211 48.531 49.1226 47.7855 49.1891C47.04 49.2556 48.0305 48.1391 48.0305 48.1391Z",
    fill: "#0094DE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M48.153 42.4756L48.3105 42.6401L49.2905 43.6761L49.5425 47.6556L50.743 47.4666L49.7945 43.7391L51.3135 46.8961L52.577 45.6326L49.861 43.1686L49.7945 41.2121L48.405 40.5156",
    fill: "#0D3744"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9445 37.7506C45.9445 37.7506 44.751 38.3001 44.751 39.3991C44.751 40.4981 46.0425 43.1126 46.851 43.6621C47.6595 44.2116 49.0455 41.6951 49.0455 41.6951C49.0455 41.6951 51.1455 42.7031 51.7055 41.7861C52.2655 40.8691 50.421 37.8416 49.231 37.0156C48.041 36.1896 45.9445 37.7506 45.9445 37.7506Z",
    fill: "white",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9365 36.648C45.2647 37.4864 45.5405 38.3444 45.7625 39.217C45.9445 40.134 48.4225 41.695 48.6955 41.786C48.9685 41.877 49.154 38.8495 49.154 38.8495L48.4225 35.2725L44.9365 36.648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 35,
    width: 6,
    height: 7
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9365 36.648C45.2647 37.4864 45.5405 38.3444 45.7625 39.217C45.9445 40.134 48.4225 41.695 48.6955 41.786C48.9685 41.877 49.154 38.8495 49.154 38.8495L48.4225 35.2725L44.9365 36.648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4995 35.6537C48.3456 35.6105 48.1889 35.5777 48.0305 35.5557L45.5 36.4482L45.1675 37.3162C45.3355 37.7852 45.549 38.4152 45.6785 38.9262C46.0934 39.2606 46.5946 39.4706 47.124 39.5317C47.8835 39.5842 48.552 38.9962 49.0245 38.2752L48.4995 35.6537Z",
    fill: "#0094DE"
  })))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9365 36.648C45.2647 37.4864 45.5405 38.3444 45.7625 39.217C45.9445 40.134 48.4225 41.695 48.6955 41.786C48.9685 41.877 49.154 38.8495 49.154 38.8495L48.4225 35.2725L44.9365 36.648Z",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2845 35.0872C43.2845 35.0872 42.273 34.2647 42.273 35.0872C42.273 35.9097 43.1935 36.3717 43.925 36.3717",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2845 35.0872C43.2845 35.0872 42.273 34.2647 42.273 35.0872C42.273 35.9097 43.1935 36.3717 43.925 36.3717",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6955 32.4271C48.6955 32.4271 49.3395 31.4191 49.5215 32.5216C49.6053 33.2393 49.4084 33.9617 48.972 34.5376L48.6955 32.4271Z",
    fill: "white",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2845 35.0872C43.2845 35.0872 42.273 34.2647 42.273 35.0872C42.273 35.9097 43.1935 36.3717 43.925 36.3717",
    fill: "#0094DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2845 35.0872C43.2845 35.0872 42.273 34.2647 42.273 35.0872C42.273 35.9097 43.1935 36.3717 43.925 36.3717",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.6955 32.4271C48.6955 32.4271 49.3395 31.4191 49.5215 32.5216C49.6053 33.2393 49.4084 33.9617 48.972 34.5376L48.6955 32.4271Z",
    fill: "#0094DE",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.147 32.434C42.147 32.434 42.9345 35.7135 44.625 37.334C46.3155 38.9545 48.125 38.9685 48.7515 36.081C49.266 33.701 47.9885 30.5265 47.9885 30.5265C47.9885 30.5265 43.8655 27.1315 42.147 32.434Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 29,
    width: 7,
    height: 10
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42.147 32.434C42.147 32.434 42.9345 35.7135 44.625 37.334C46.3155 38.9545 48.125 38.9685 48.7515 36.081C49.266 33.701 47.9885 30.5265 47.9885 30.5265C47.9885 30.5265 43.8655 27.1315 42.147 32.434Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0836 29.4585L45.7241 31.0685C45.7241 31.0685 46.7321 30.8445 47.2991 32.0625C47.8661 33.2805 48.4366 35.0655 48.1111 36.448C47.7996 37.764 47.0611 38.198 45.9236 38.2295C47.1626 38.758 48.2861 38.2295 48.7516 36.0735C49.2661 33.6935 47.9886 30.519 47.9886 30.519C47.9886 30.519 46.5921 29.3745 45.0836 29.4585Z",
    fill: "#0094DE"
  })))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.147 32.434C42.147 32.434 42.9345 35.7135 44.625 37.334C46.3155 38.9545 48.125 38.9685 48.7515 36.081C49.266 33.701 47.9885 30.5265 47.9885 30.5265C47.9885 30.5265 43.8655 27.1315 42.147 32.434Z",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M45.276 34.167C45.374 34.3525 45.3565 34.552 45.2375 34.615C45.1185 34.678 44.9435 34.5765 44.849 34.391C44.7545 34.2055 44.7685 34.0095 44.8875 33.9465C45.0065 33.8835 45.1815 33.985 45.276 34.167Z",
    fill: "#0D3744"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M47.103 33.5995C47.173 33.7955 47.1275 33.9915 47.0015 34.0335C46.8755 34.0755 46.7145 33.9565 46.6515 33.7605C46.5885 33.5645 46.627 33.3685 46.753 33.3265C46.879 33.2845 47.033 33.4105 47.103 33.5995Z",
    fill: "#0D3744"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M47.229 32.5499C47.086 32.4538 46.9155 32.4073 46.7436 32.4174C46.5716 32.4275 46.4077 32.4937 46.277 32.6059C45.773 32.9979 46.725 34.9614 46.725 34.9614C46.725 34.9614 46.7425 35.5809 45.948 35.2939",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M47.229 35.9307C47.1745 36.0596 47.0908 36.174 46.9845 36.265C46.8782 36.356 46.7521 36.421 46.6164 36.455C46.4806 36.4889 46.3388 36.4908 46.2022 36.4606C46.0655 36.4303 45.9378 36.3687 45.829 36.2807",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0975 33.0711C45.0975 33.0711 44.2015 32.2276 43.8095 33.8551",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M48.041 29.4876C47.0575 28.6336 46.263 28.6441 45.9165 28.7561C45.5922 28.5537 45.2233 28.4336 44.842 28.4061C42.091 28.0386 41.7235 30.1561 41.7235 32.1686C41.7235 34.1811 39.9735 36.5716 41.174 36.8481C41.5025 36.927 41.8483 36.8873 42.1505 36.7362C42.4527 36.5851 42.6919 36.3323 42.826 36.0221C42.826 36.0221 44.1105 33.9221 44.1105 32.4416C44.1105 30.9611 45.71 31.1011 45.71 31.1011C45.7791 30.9992 45.8693 30.9134 45.9747 30.8496C46.08 30.7858 46.1979 30.7456 46.3202 30.7316C46.4425 30.7176 46.5665 30.7303 46.6834 30.7687C46.8004 30.8071 46.9077 30.8704 46.998 30.9541C47.726 31.5771 47.81 32.3086 48.398 32.4976C48.986 32.6866 49.9695 31.7416 49.9695 31.7416C49.4092 30.9234 48.7627 30.1677 48.041 29.4876Z",
    fill: "#0D3744"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M45.787 30.0367C45.787 30.0367 44.681 29.1477 43.687 30.1452C42.693 31.1427 42.8015 33.0292 42.469 34.2507C42.1365 35.4722 41.2475 35.6927 41.2475 35.6927",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0135 29.7043C45.0135 29.7043 43.82 28.5213 42.3185 30.0193C41.174 31.1673 41.685 31.9198 41.461 33.8063",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3435 29.4801C46.3435 29.4801 48.4435 28.4826 49.3395 31.0341",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8145 41.877L38.64 54.6519L47.95 57.291L48.4085 55.639L42.294 52.818L44.3695 45.468C44.3695 45.468 44.0965 44.0925 42.6195 42.535",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 41,
    width: 11,
    height: 17
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8145 41.877L38.64 54.6519L47.95 57.291L48.4085 55.639L42.294 52.818L44.3695 45.468C44.3695 45.468 44.0965 44.0925 42.6195 42.535",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4225 55.6492L42.308 52.8282L44.3835 45.4782C44.221 44.8681 43.9571 44.2895 43.603 43.7667L43.4035 43.6162V45.6462C43.4035 46.9447 41.7795 51.0852 41.209 52.0582C40.6385 53.0312 39.7495 54.2492 39.7495 54.2492L41.5345 53.4372L48.3 56.1462L48.4225 55.6492Z",
    fill: "#0094DE"
  })))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8145 41.877L38.64 54.652L47.95 57.291L48.4085 55.639L42.294 52.818L44.3695 45.468C44.3695 45.468 44.0965 44.0925 42.6195 42.535",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M67.991 45.7131L60.942 44.2326L53.7425 35.9131L54.8065 42.6051L59.2235 46.8121L68.0995 47.2181L67.991 45.7131Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 35,
    width: 16,
    height: 13
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M67.991 45.7131L60.942 44.2326L53.7425 35.9131L54.8065 42.6051L59.2235 46.8121L68.0995 47.2181L67.991 45.7131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7425 35.9131L54.6 41.2541L55.146 42.9236L55.216 42.9866C55.4225 42.7731 56.588 41.5621 56.8855 41.5621C57.183 41.5621 60.5395 44.4846 60.053 44.7121L59.563 44.9536L67.9245 46.3326L67.984 45.6921L60.949 44.2151L53.7425 35.9131Z",
    fill: "#0094DE"
  })))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M67.991 45.7131L60.942 44.2326L53.7425 35.9131L54.8065 42.6051L59.2235 46.8121L68.0995 47.2181L67.991 45.7131Z",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M133.795 116.55L44.03 103.397C43.7447 103.355 43.4878 103.201 43.3158 102.969C43.1439 102.738 43.0709 102.447 43.113 102.162L50.589 51.1631C50.6096 51.022 50.6578 50.8863 50.7309 50.7638C50.8039 50.6412 50.9004 50.5343 51.0149 50.4492C51.1293 50.364 51.2594 50.3022 51.3977 50.2674C51.5361 50.2326 51.6799 50.2253 51.821 50.2461L53.522 50.4947C53.7375 50.527 53.9577 50.4935 54.1538 50.3986C54.3499 50.3036 54.5127 50.1517 54.621 49.9627L56.8785 46.0602C56.9471 45.9376 57.04 45.8304 57.1515 45.7451C57.68 45.363 58.3368 45.2023 58.982 45.2971L81.6095 48.6151C82.1171 48.688 82.59 48.9153 82.964 49.2661C83.0638 49.3661 83.1423 49.4851 83.195 49.6161L85.2075 54.6002C85.2781 54.7764 85.3939 54.931 85.5432 55.0484C85.6925 55.1657 85.8701 55.2417 86.058 55.2687L141.586 63.4096C141.871 63.4512 142.128 63.6043 142.301 63.8353C142.473 64.0662 142.547 64.3563 142.506 64.6417L135.03 115.637C134.987 115.921 134.833 116.177 134.601 116.349C134.369 116.52 134.079 116.592 133.795 116.55Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M134.75 116.301H45.7765C45.5182 116.301 45.2624 116.25 45.0238 116.151C44.7851 116.052 44.5683 115.908 44.3856 115.725C44.203 115.542 44.0581 115.325 43.9592 115.087C43.8604 114.848 43.8095 114.592 43.8095 114.334V64.5501C43.8095 64.0284 44.0167 63.5281 44.3856 63.1592C44.7545 62.7903 45.2548 62.5831 45.7765 62.5831H46.018C46.4118 62.5823 46.7964 62.4639 47.1225 62.2432C47.4487 62.0225 47.7014 61.7094 47.8485 61.3441L49.203 57.9386C49.3544 57.5455 49.6312 57.2134 49.9905 56.9936C50.3765 56.7657 50.8163 56.6448 51.2645 56.6436H74.1335C74.4409 56.6432 74.7457 56.699 75.033 56.8081C75.4322 56.9689 75.7652 57.26 75.978 57.6341L78.3055 61.5996C78.479 61.8958 78.7269 62.1414 79.0247 62.3121C79.3225 62.4828 79.6598 62.5726 80.003 62.5726H134.75C135.272 62.5726 135.772 62.7798 136.141 63.1487C136.51 63.5176 136.717 64.0179 136.717 64.5396V114.334C136.717 114.592 136.666 114.848 136.567 115.087C136.468 115.325 136.324 115.542 136.141 115.725C135.958 115.908 135.741 116.052 135.503 116.151C135.264 116.25 135.008 116.301 134.75 116.301Z",
    fill: "#0094DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 56,
    width: 94,
    height: 61
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M134.75 116.301H45.7765C45.5182 116.301 45.2624 116.25 45.0238 116.151C44.7851 116.052 44.5683 115.908 44.3856 115.725C44.203 115.542 44.0581 115.325 43.9592 115.087C43.8604 114.848 43.8095 114.592 43.8095 114.334V64.5501C43.8095 64.0284 44.0167 63.5281 44.3856 63.1592C44.7545 62.7903 45.2548 62.5831 45.7765 62.5831H46.018C46.4118 62.5823 46.7964 62.4639 47.1225 62.2432C47.4487 62.0225 47.7014 61.7094 47.8485 61.3441L49.203 57.9386C49.3544 57.5455 49.6312 57.2134 49.9905 56.9936C50.3765 56.7657 50.8163 56.6448 51.2645 56.6436H74.1335C74.4409 56.6432 74.7457 56.699 75.033 56.8081C75.4322 56.9689 75.7652 57.26 75.978 57.6341L78.3055 61.5996C78.479 61.8958 78.7269 62.1414 79.0247 62.3121C79.3225 62.4828 79.6598 62.5726 80.003 62.5726H134.75C135.272 62.5726 135.772 62.7798 136.141 63.1487C136.51 63.5176 136.717 64.0179 136.717 64.5396V114.334C136.717 114.592 136.666 114.848 136.567 115.087C136.468 115.325 136.324 115.542 136.141 115.725C135.958 115.908 135.741 116.052 135.503 116.151C135.264 116.25 135.008 116.301 134.75 116.301Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_327_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.75 116.301H45.7765C45.5182 116.301 45.2624 116.25 45.0238 116.151C44.7851 116.052 44.5683 115.908 44.3856 115.725C44.203 115.542 44.0581 115.325 43.9592 115.087C43.8604 114.848 43.8095 114.592 43.8095 114.334V64.5501C43.8095 64.0284 44.0167 63.5281 44.3856 63.1592C44.7545 62.7903 45.2548 62.5831 45.7765 62.5831H46.018C46.4118 62.5823 46.7964 62.4639 47.1225 62.2432C47.4487 62.0225 47.7014 61.7094 47.8485 61.3441L49.203 57.9386C49.3544 57.5455 49.6312 57.2134 49.9905 56.9936C50.3765 56.7657 50.8163 56.6448 51.2645 56.6436H74.1335C74.4409 56.6432 74.7457 56.699 75.033 56.8081C75.4322 56.9689 75.7652 57.26 75.978 57.6341L78.3055 61.5996C78.479 61.8958 78.7269 62.1414 79.0247 62.3121C79.3225 62.4828 79.6598 62.5726 80.003 62.5726H134.75C135.272 62.5726 135.772 62.7798 136.141 63.1487C136.51 63.5176 136.717 64.0179 136.717 64.5396V114.334C136.717 114.592 136.666 114.848 136.567 115.087C136.468 115.325 136.324 115.542 136.141 115.725C135.958 115.908 135.741 116.052 135.503 116.151C135.264 116.25 135.008 116.301 134.75 116.301Z",
    fill: "#0D3744"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M134.75 116.301H45.7765C45.5182 116.301 45.2624 116.25 45.0238 116.151C44.7851 116.052 44.5683 115.908 44.3856 115.725C44.203 115.542 44.0581 115.325 43.9592 115.087C43.8604 114.848 43.8095 114.592 43.8095 114.334V64.5501C43.8095 64.0284 44.0167 63.5281 44.3856 63.1592C44.7545 62.7903 45.2548 62.5831 45.7765 62.5831H46.018C46.4118 62.5823 46.7964 62.4639 47.1225 62.2432C47.4487 62.0225 47.7014 61.7094 47.8485 61.3441L49.203 57.9386C49.3544 57.5455 49.6312 57.2134 49.9905 56.9936C50.3765 56.7657 50.8163 56.6448 51.2645 56.6436H74.1335C74.4409 56.6432 74.7457 56.699 75.033 56.8081C75.4322 56.9689 75.7652 57.26 75.978 57.6341L78.3055 61.5996C78.479 61.8957 78.7269 62.1414 79.0247 62.3121C79.3225 62.4828 79.6598 62.5726 80.003 62.5726H134.75C135.272 62.5726 135.772 62.7798 136.141 63.1487C136.51 63.5176 136.717 64.0179 136.717 64.5396V114.334C136.717 114.592 136.666 114.848 136.567 115.087C136.468 115.325 136.324 115.542 136.141 115.725C135.958 115.908 135.741 116.052 135.503 116.151C135.264 116.25 135.008 116.301 134.75 116.301Z",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M68.95 62.4151H54.712C54.3723 62.4151 54.0465 62.2801 53.8062 62.0399C53.566 61.7997 53.431 61.4739 53.431 61.1341C53.4306 60.9656 53.4634 60.7986 53.5275 60.6428C53.5917 60.487 53.686 60.3454 53.805 60.226C53.924 60.1067 54.0654 60.012 54.221 59.9475C54.3767 59.8829 54.5435 59.8496 54.712 59.8496H68.95C69.2907 59.8496 69.6174 59.9849 69.8583 60.2258C70.0992 60.4667 70.2345 60.7934 70.2345 61.1341C70.2345 61.3026 70.2013 61.4695 70.1367 61.6251C70.0721 61.7808 69.9774 61.9222 69.8581 62.0412C69.7388 62.1601 69.5971 62.2544 69.4413 62.3186C69.2855 62.3828 69.1186 62.4156 68.95 62.4151Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M134.75 124.988H45.7765C45.2548 124.988 44.7545 124.781 44.3856 124.412C44.0167 124.043 43.8095 123.543 43.8095 123.021V73.237C43.8095 72.7153 44.0167 72.215 44.3856 71.8461C44.7545 71.4772 45.2548 71.27 45.7765 71.27H46.018C46.4119 71.2697 46.7967 71.1515 47.1229 70.9307C47.4492 70.7099 47.7018 70.3966 47.8485 70.031L49.203 66.629C49.3535 66.2354 49.6305 65.903 49.9905 65.684C50.3759 65.4547 50.8161 65.3337 51.2645 65.334H74.1335C74.4409 65.3337 74.7457 65.3894 75.033 65.4985C75.4332 65.6595 75.7665 65.9521 75.978 66.328L78.3055 70.297C78.479 70.5932 78.7269 70.8388 79.0247 71.0095C79.3225 71.1802 79.6598 71.27 80.003 71.27H134.75C135.272 71.27 135.772 71.4772 136.141 71.8461C136.51 72.215 136.717 72.7153 136.717 73.237V123.021C136.717 123.543 136.51 124.043 136.141 124.412C135.772 124.781 135.272 124.988 134.75 124.988Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7715 52.1503L61.6455 50.4003C61.3081 50.3574 61.0013 50.1829 60.7922 49.9147C60.583 49.6465 60.4884 49.3065 60.529 48.9688C60.5718 48.631 60.747 48.3239 61.0161 48.1152C61.2852 47.9065 61.6261 47.8132 61.964 47.8558L76.0865 49.6058C76.4243 49.6478 76.7316 49.8221 76.9409 50.0905C77.1503 50.3589 77.2445 50.6995 77.203 51.0373C77.1822 51.2044 77.1287 51.3658 77.0455 51.5123C76.9623 51.6587 76.851 51.7873 76.7181 51.8907C76.5851 51.994 76.433 52.0702 76.2706 52.1147C76.1082 52.1593 75.9386 52.1714 75.7715 52.1503Z",
    fill: "#0094DE"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.7715 52.1503L61.6455 50.4003C61.3081 50.3574 61.0013 50.1829 60.7922 49.9147C60.583 49.6465 60.4884 49.3065 60.529 48.9688C60.5718 48.631 60.747 48.3239 61.0161 48.1152C61.2852 47.9065 61.6261 47.8132 61.964 47.8558L76.0865 49.6058C76.4243 49.6478 76.7316 49.8221 76.9409 50.0905C77.1503 50.3589 77.2445 50.6995 77.203 51.0373C77.1822 51.2044 77.1287 51.3658 77.0455 51.5123C76.9623 51.6587 76.851 51.7873 76.7181 51.8907C76.5851 51.994 76.433 52.0702 76.2706 52.1147C76.1082 52.1593 75.9386 52.1714 75.7715 52.1503Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M68.95 71.1061H54.712C54.5435 71.1061 54.3767 71.0729 54.221 71.0083C54.0654 70.9437 53.924 70.849 53.805 70.7297C53.686 70.6103 53.5917 70.4687 53.5275 70.3129C53.4634 70.1571 53.4306 69.9901 53.431 69.8216C53.431 69.4815 53.5659 69.1554 53.806 68.9146C54.0462 68.6738 54.372 68.538 54.712 68.5371H68.95C69.2907 68.5371 69.6174 68.6724 69.8583 68.9133C70.0992 69.1542 70.2345 69.4809 70.2345 69.8216C70.2345 70.1623 70.0992 70.489 69.8583 70.7299C69.6174 70.9708 69.2907 71.1061 68.95 71.1061Z",
    fill: "#0094DE"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.95 71.1061H54.712C54.5435 71.1061 54.3767 71.0729 54.221 71.0083C54.0654 70.9437 53.924 70.849 53.805 70.7297C53.686 70.6103 53.5917 70.4687 53.5275 70.3129C53.4634 70.1571 53.4306 69.9901 53.431 69.8216C53.431 69.4815 53.5659 69.1554 53.806 68.9146C54.0462 68.6738 54.372 68.538 54.712 68.5371H68.95C69.2907 68.5371 69.6174 68.6724 69.8583 68.9133C70.0992 69.1542 70.2345 69.4809 70.2345 69.8216C70.2345 70.1623 70.0992 70.489 69.8583 70.7299C69.6174 70.9708 69.2907 71.1061 68.95 71.1061Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M137.659 86.2432H42.8645C41.8458 86.2432 41.02 87.069 41.02 88.0877V145.449C41.02 146.468 41.8458 147.294 42.8645 147.294H137.659C138.677 147.294 139.503 146.468 139.503 145.449V88.0877C139.503 87.069 138.677 86.2432 137.659 86.2432Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 86,
    width: 99,
    height: 62
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M137.659 86.2432H42.8645C41.8458 86.2432 41.02 87.069 41.02 88.0877V145.449C41.02 146.468 41.8458 147.294 42.8645 147.294H137.659C138.677 147.294 139.503 146.468 139.503 145.449V88.0877C139.503 87.069 138.677 86.2432 137.659 86.2432Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M139.503 102.676C128.586 112.879 116.183 121.364 102.718 127.841C82.8205 137.357 60.0775 143.916 46.8265 147.294H137.655C137.898 147.294 138.138 147.247 138.362 147.154C138.586 147.062 138.79 146.926 138.962 146.755C139.133 146.583 139.269 146.38 139.362 146.156C139.455 145.932 139.503 145.692 139.503 145.449V102.676Z",
    fill: "#0094DE"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.503 102.676C128.586 112.879 116.183 121.364 102.718 127.841C82.8205 137.357 60.0775 143.916 46.8265 147.294H137.655C137.898 147.294 138.138 147.247 138.362 147.154C138.586 147.062 138.79 146.926 138.962 146.755C139.133 146.583 139.269 146.38 139.362 146.156C139.455 145.932 139.503 145.692 139.503 145.449V102.676Z",
    fill: "white"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M137.659 86.2432H42.8645C41.8458 86.2432 41.02 87.069 41.02 88.0877V145.449C41.02 146.468 41.8458 147.294 42.8645 147.294H137.659C138.677 147.294 139.503 146.468 139.503 145.449V88.0877C139.503 87.069 138.677 86.2432 137.659 86.2432Z",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4445 91.605V89.155C42.4454 88.6655 42.6406 88.1964 42.987 87.8506C43.3335 87.5048 43.803 87.3105 44.2925 87.3105H48.3",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4445 128.814V94.5908",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M138.075 140.49V144.365C138.075 144.607 138.028 144.847 137.936 145.072C137.843 145.296 137.707 145.5 137.536 145.671C137.365 145.843 137.161 145.979 136.937 146.072C136.713 146.165 136.473 146.213 136.231 146.213H133",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M138.075 90.7441V137.609",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M104.902 108.566H75.6175C75.0898 108.566 74.662 108.994 74.662 109.522V124.463C74.662 124.991 75.0898 125.419 75.6175 125.419H104.902C105.43 125.419 105.857 124.991 105.857 124.463V109.522C105.857 108.994 105.43 108.566 104.902 108.566Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M104.902 108.566H75.6175C75.0898 108.566 74.662 108.994 74.662 109.522V112.735C74.662 113.263 75.0898 113.69 75.6175 113.69H104.902C105.43 113.69 105.857 113.263 105.857 112.735V109.522C105.857 108.994 105.43 108.566 104.902 108.566Z",
    fill: "white",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M47.95 57.2918L48.5905 58.4853L49.952 59.4653C50.0376 59.5281 50.1401 59.5638 50.2463 59.5675C50.3524 59.5713 50.4572 59.543 50.547 59.4863L50.666 59.4093C50.7526 59.3567 50.817 59.2744 50.8473 59.1778C50.8776 59.0812 50.8716 58.9768 50.8305 58.8843L50.057 57.1063L50.5785 57.5123C50.6613 57.5761 50.7657 57.6052 50.8695 57.5934C50.9734 57.5817 51.0686 57.53 51.135 57.4493C51.1927 57.3773 51.2241 57.2878 51.2241 57.1955C51.2241 57.1033 51.1927 57.0138 51.135 56.9418L49.9205 55.4053L48.4015 55.6398L47.95 57.2918Z",
    fill: "white",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M50.68 59.4091L49.462 57.8096",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M49.966 59.4652L49.0105 58.1982",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M67.991 45.7129L69.895 45.8249L72.212 47.3054C72.212 47.3054 72.3415 47.7569 72.0195 47.8199C71.6975 47.8829 69.958 47.2424 69.958 47.2424L68.0995 47.2179L67.991 45.7129Z",
    fill: "white",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M68.089 46.9835L70.0875 47.8865C70.0875 47.8865 70.4095 47.435 69.958 47.2425L69.3 46.791",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M68.089 46.9835L70.0875 47.8865C70.0875 47.8865 70.4095 47.435 69.958 47.2425L69.3 46.791",
    stroke: "#0D3744",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 81.1156L137.869 78.6446L136.941 77.3741C136.926 77.3509 136.903 77.3334 136.877 77.3243C136.851 77.3152 136.822 77.3151 136.796 77.3238C136.77 77.3326 136.747 77.3499 136.731 77.3729C136.716 77.3959 136.708 77.4234 136.71 77.4511V81.1121L137.41 82.0326L138.695 81.1156Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M152.156 91.9197L145.226 92.1647C144.97 92.1737 144.717 92.1096 144.496 91.9801C144.276 91.8506 144.096 91.6609 143.98 91.4332L138.695 81.1152C138.695 81.1152 137.505 81.7592 137.414 82.0322C137.323 82.3052 141.327 92.3467 142.555 95.4302C142.658 95.6891 142.839 95.9096 143.073 96.0612C143.307 96.2129 143.582 96.2884 143.861 96.2772L151.606 95.9482",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M152.156 91.9197L145.226 92.1647C144.97 92.1737 144.717 92.1096 144.496 91.9801C144.276 91.8506 144.096 91.6609 143.98 91.4332L138.695 81.1152C138.695 81.1152 137.505 81.7592 137.414 82.0322C137.323 82.3052 141.327 92.3467 142.555 95.4302C142.658 95.6891 142.839 95.9096 143.073 96.0612C143.307 96.2129 143.582 96.2884 143.861 96.2772L151.606 95.9482",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M139.202 82.4004L138.117 82.8484",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.156 91.9197L145.226 92.1647C144.97 92.1737 144.717 92.1096 144.496 91.9801C144.276 91.8506 144.096 91.6609 143.98 91.4332L138.695 81.1152C138.695 81.1152 137.505 81.7592 137.414 82.0322C137.323 82.3052 141.327 92.3467 142.555 95.4302C142.658 95.6891 142.839 95.9096 143.073 96.0612C143.307 96.2129 143.582 96.2884 143.861 96.2772L151.606 95.9482",
    fill: "#0094DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.156 91.9197L145.226 92.1647C144.97 92.1737 144.717 92.1096 144.496 91.9801C144.276 91.8506 144.096 91.6609 143.98 91.4332L138.695 81.1152C138.695 81.1152 137.505 81.7592 137.414 82.0322C137.323 82.3052 141.327 92.3467 142.555 95.4302C142.658 95.6891 142.839 95.9096 143.073 96.0612C143.307 96.2129 143.582 96.2884 143.861 96.2772L151.606 95.9482",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.202 82.3994L138.117 82.8474",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 81.1156L137.869 78.6446L136.941 77.3741C136.926 77.3509 136.903 77.3334 136.877 77.3243C136.851 77.3152 136.822 77.3151 136.796 77.3238C136.77 77.3326 136.747 77.3499 136.731 77.3729C136.716 77.3959 136.708 77.4234 136.71 77.4511V81.1121L137.41 82.0326L138.695 81.1156Z",
    fill: "#0094DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 77,
    width: 3,
    height: 6
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 81.1156L137.869 78.6446L136.941 77.3741C136.926 77.3509 136.903 77.3334 136.877 77.3243C136.851 77.3152 136.822 77.3151 136.796 77.3238C136.77 77.3326 136.747 77.3499 136.731 77.3729C136.716 77.3959 136.708 77.4234 136.71 77.4511V81.1121L137.41 82.0326L138.695 81.1156Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_327_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.695 81.1156L137.869 78.6446L136.941 77.3741C136.926 77.3509 136.903 77.3334 136.877 77.3243C136.851 77.3152 136.822 77.3151 136.796 77.3238C136.77 77.3326 136.747 77.3499 136.731 77.3729C136.716 77.3959 136.708 77.4234 136.71 77.4511V81.1121L137.41 82.0326L138.695 81.1156Z",
    fill: "white"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 81.1156L137.869 78.6446L136.941 77.3741C136.926 77.3509 136.903 77.3334 136.877 77.3243C136.851 77.3152 136.822 77.3151 136.796 77.3238C136.77 77.3326 136.747 77.3499 136.731 77.3729C136.716 77.3959 136.708 77.4234 136.71 77.4511V81.1121L137.41 82.0326L138.695 81.1156Z",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M154.301 85.3993C153.968 85.8211 153.73 86.3092 153.601 86.8308C153.5 87.5028 153.661 90.0893 153.661 90.0893L150.056 90.4953C150.056 90.4953 150.329 87.8668 150.343 87.4293C150.458 86.8868 150.688 86.3751 151.017 85.9285C151.346 85.4818 151.766 85.1105 152.25 84.8393C153.489 84.2303 154.543 84.5278 154.301 85.3993Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 84,
    width: 5,
    height: 7
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M154.301 85.3993C153.968 85.8211 153.73 86.3092 153.601 86.8308C153.5 87.5028 153.661 90.0893 153.661 90.0893L150.056 90.4953C150.056 90.4953 150.329 87.8668 150.343 87.4293C150.458 86.8868 150.688 86.3751 151.017 85.9285C151.346 85.4818 151.766 85.1105 152.25 84.8393C153.489 84.2303 154.543 84.5278 154.301 85.3993Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M154.277 85.4277C153.622 85.2492 152.828 85.0497 152.156 84.8887C151.694 85.1637 151.293 85.5309 150.979 85.9675C150.666 86.4041 150.445 86.9006 150.332 87.4262C150.332 87.5942 150.283 88.0842 150.234 88.6232C150.584 88.5427 151.141 88.4202 151.554 88.3467C151.881 88.2939 152.203 88.2131 152.516 88.1052L152.394 90.2052H152.474L153.65 90.0722C153.65 90.0722 153.489 87.4857 153.591 86.8137C153.718 86.3083 153.952 85.8358 154.277 85.4277Z",
    fill: "#0094DE"
  })))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M154.301 85.3993C153.968 85.8211 153.73 86.3092 153.601 86.8308C153.5 87.5028 153.661 90.0893 153.661 90.0893L150.056 90.4953C150.056 90.4953 150.329 87.8668 150.343 87.4293C150.458 86.8868 150.688 86.3751 151.017 85.9285C151.346 85.4818 151.766 85.1105 152.25 84.8393C153.489 84.2303 154.543 84.5278 154.301 85.3993Z",
    stroke: "#0D3744",
    strokeWidth: 1.00396,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05 85.8438C158.039 81.8958 150.833 77.7938 148.939 81.7173C148.675 82.2011 148.466 82.713 148.316 83.2433C148.029 83.4183 147.266 83.8873 147.126 84.0168C146.986 84.1463 147.476 84.4788 147.746 84.6433C147.231 85.9068 147.308 87.2368 147.455 87.5378C147.711 88.0558 148.971 88.0628 149.8 87.9088C150.63 87.7548 150.959 86.9603 151.2 86.7433C151.442 86.5263 152.646 86.8028 153.069 86.9288C153.493 87.0548 154.469 86.6243 155.05 85.8438Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 80,
    width: 9,
    height: 8
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05 85.8438C158.039 81.8958 150.833 77.7938 148.939 81.7173C148.675 82.2011 148.466 82.713 148.316 83.2433C148.029 83.4183 147.266 83.8873 147.126 84.0168C146.986 84.1463 147.476 84.4788 147.746 84.6433C147.231 85.9068 147.308 87.2368 147.455 87.5378C147.711 88.0558 148.971 88.0628 149.8 87.9088C150.63 87.7548 150.959 86.9603 151.2 86.7433C151.442 86.5263 152.646 86.8028 153.069 86.9288C153.493 87.0548 154.469 86.6243 155.05 85.8438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.093 85.4658C152.093 85.4658 152.156 85.7633 151.554 86.0048C150.952 86.2463 150.833 86.0643 150.654 86.4843C150.578 86.7605 150.425 87.0091 150.212 87.2008C149.999 87.3925 149.736 87.5192 149.454 87.5658C148.883 87.6741 148.307 87.7477 147.728 87.7863C148.204 88.0523 149.149 88.0313 149.828 87.9088C150.654 87.7583 150.987 86.9603 151.228 86.7433C151.47 86.5263 152.674 86.8028 153.097 86.9288C153.196 86.9486 153.299 86.9486 153.398 86.9288C153.556 86.5771 153.651 86.2004 153.678 85.8158L152.093 85.4658Z",
    fill: "#0094DE"
  })))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05 85.8438C158.039 81.8958 150.833 77.7938 148.939 81.7173C148.675 82.2011 148.466 82.713 148.316 83.2433C148.029 83.4183 147.266 83.8873 147.126 84.0168C146.986 84.1463 147.476 84.4788 147.746 84.6433C147.231 85.9068 147.308 87.2368 147.455 87.5378C147.711 88.0558 148.971 88.0628 149.8 87.9088C150.63 87.7548 150.959 86.9603 151.2 86.7433C151.442 86.5263 152.646 86.8028 153.069 86.9288C153.493 87.0548 154.469 86.6243 155.05 85.8438Z",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M149.212 83.5905C149.135 83.7585 149.005 83.8635 148.921 83.825C148.837 83.7865 148.83 83.6185 148.921 83.4505C149.012 83.2825 149.128 83.1775 149.212 83.216C149.296 83.2545 149.289 83.4225 149.212 83.5905Z",
    fill: "#0D3744"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M149.142 82.512C149.142 82.512 149.492 82.2215 149.562 82.89",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M147.676 85.3223C147.676 85.3223 147.676 85.6723 148.306 85.6723",
    stroke: "#0D3744",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M146.822 108.227L146.545 111.65C146.545 111.65 144.631 125.279 144.722 126.843C144.813 128.408 145.019 144.571 145.019 144.571L147.326 144.938L149.916 127.011L153.552 108.794L146.822 108.227Z",
    fill: "#0094DE",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.822 108.227L146.545 111.65C146.545 111.65 144.631 125.279 144.722 126.843C144.813 128.408 145.019 144.571 145.019 144.571L147.326 144.938L149.916 127.011L153.552 108.794L146.822 108.227Z",
    fill: "#0D3744"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.741 120.676C149.741 120.676 148.855 125.887 148.187 128.442C147.518 130.997 147.522 133.545 147.522 136.317C147.522 139.089 146.524 144.199 146.524 144.199",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M151.501 107.387C153.02 106.589 154.651 106.06 155.117 107.121C156.041 109.242 154.935 112.465 154.935 112.465L155.778 127.333L157.322 145.271L155.015 144.9C155.015 144.9 151.473 129.762 150.92 128.838C150.367 127.914 149.496 114.954 149.496 114.954L147.746 113.361",
    fill: "#0094DE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M151.501 107.387C153.02 106.589 154.651 106.06 155.117 107.121C156.041 109.242 154.935 112.465 154.935 112.465L155.778 127.333L157.322 145.271L155.015 144.9C155.015 144.9 151.473 129.762 150.92 128.838C150.367 127.914 149.496 114.954 149.496 114.954L147.746 113.361",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.501 107.387C153.02 106.589 154.651 106.06 155.117 107.121C156.041 109.242 154.935 112.465 154.935 112.465L155.778 127.333L157.322 145.271L155.015 144.9C155.015 144.9 151.473 129.762 150.92 128.838C150.367 127.914 149.496 114.954 149.496 114.954L147.746 113.361",
    fill: "#0D3744"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 118.649C153.352 122.097 153.702 123.756 153.975 124.666C154.308 125.775 154.196 127.882 154.196 128.866C154.196 129.849 153.751 128.645 154.752 133.195C155.753 137.745 156.415 144.066 156.415 144.066",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 111.135C153.3 111.135 153.408 110.911 153.3 116.126C153.3 116.406 153.3 116.676 153.3 116.938",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M148.18 110.145L148.106 111.706L147.746 112.791L148.285 113.421",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M147.473 111.075C147.473 111.075 148.376 111.978 150.721 111.705",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M153.013 110.296C154.763 109.946 154.875 109.463 155.481 109.057C155.492 108.395 155.373 107.737 155.131 107.121C154.672 106.071 153.031 106.589 151.515 107.387L150.78 108.549L146.836 108.227L146.71 109.774C148.735 110.469 150.901 110.648 153.013 110.296Z",
    fill: "#0D3744"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M147.217 109.298L147.179 109.914L148.18 110.145L148.257 109.336L147.217 109.298Z",
    fill: "white",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M154.203 110.211L154.035 108.678L154.543 108.51L154.798 109.871",
    fill: "#0094DE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M154.203 110.211L154.035 108.678L154.543 108.51L154.798 109.871",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 110.722L149.951 108.934H150.801L151.14 110.467",
    fill: "#0094DE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 110.722L149.951 108.934H150.801L151.14 110.467",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.203 110.211L154.035 108.678L154.543 108.51L154.798 109.871",
    fill: "#0D3744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29 110.722L149.951 108.934H150.801L151.14 110.467",
    fill: "#0D3744"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M146.37 94.6602C146.37 94.6602 146.08 96.6027 145.208 99.9102C144.337 103.218 143.458 107.183 143.458 107.183L143.945 109.22L145.397 107.085L146.37 94.6602Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M148.795 91.8504C148.795 91.8504 146.758 92.3334 146.566 93.3029C146.462 93.7492 146.397 94.2035 146.37 94.6609L149.474 92.1409L153.356 90.5869L148.795 91.8504Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M149.352 91.1015C149.352 91.1015 147.697 92.974 147.039 93.744C146.381 94.514 146.377 102.777 146.377 103.992C146.377 105.206 145.719 108.503 146.818 109.165C147.917 109.826 154.641 109.606 155.302 108.503C155.964 107.401 156.401 94.185 156.293 92.974C156.21 92.4307 155.996 91.9158 155.669 91.4741C155.342 91.0325 154.912 90.6774 154.417 90.44C153.65 90.0865 149.352 91.1015 149.352 91.1015Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_327_8258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 90,
    width: 11,
    height: 20
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M149.352 91.1015C149.352 91.1015 147.697 92.974 147.039 93.744C146.381 94.514 146.377 102.777 146.377 103.992C146.377 105.206 145.719 108.503 146.818 109.165C147.917 109.826 154.641 109.606 155.302 108.503C155.964 107.401 156.401 94.185 156.293 92.974C156.21 92.4307 155.996 91.9158 155.669 91.4741C155.342 91.0325 154.912 90.6774 154.417 90.44C153.65 90.0865 149.352 91.1015 149.352 91.1015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_327_8258)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M154.417 90.44C154.325 90.403 154.228 90.3817 154.129 90.377L153.654 90.6255C154.455 91.2819 155.006 92.1939 155.215 93.2085C155.436 94.6824 155.416 96.1825 155.155 97.65C154.917 99.2705 151.074 97.65 151.795 98.252C152.516 98.854 155.215 99.8725 155.337 100.411C155.46 100.95 154 101.85 153.475 101.913C152.95 101.976 153.825 103.173 154.375 104.191C154.924 105.21 154.725 106.641 153.475 107.614C152.226 108.587 149.324 109.067 148.071 109.116C147.665 109.116 147.413 109.221 147.336 109.34C149.261 109.77 154.711 109.49 155.302 108.503C155.964 107.401 156.401 94.185 156.292 92.974C156.21 92.4307 155.996 91.9157 155.669 91.4741C155.342 91.0324 154.912 90.6774 154.417 90.44Z",
    fill: "#0094DE"
  })))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M149.352 91.1015C149.352 91.1015 147.697 92.974 147.039 93.744C146.381 94.514 146.377 102.777 146.377 103.992C146.377 105.206 145.719 108.503 146.818 109.165C147.917 109.826 154.641 109.606 155.302 108.503C155.964 107.401 156.401 94.185 156.293 92.974C156.21 92.4307 155.996 91.9158 155.669 91.4741C155.342 91.0325 154.912 90.6774 154.417 90.44C153.65 90.0865 149.352 91.1015 149.352 91.1015Z",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M152.737 99.4838C150.962 98.9308 149.408 97.3838 149.408 97.3838C149.802 99.2221 150.871 100.846 152.404 101.934",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M152.737 99.4838C150.962 98.9308 149.408 97.3838 149.408 97.3838C149.802 99.2221 150.871 100.846 152.404 101.934",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M154.088 89.2285L148.799 90.4395L148.47 91.983L154.417 90.4395L154.088 89.2285Z",
    fill: "white",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M147.633 147.248L147.325 144.924L145.019 144.557L143.097 145.925L141.375 146.87V147.248H147.633Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M157.609 147.43L157.322 145.27L155.015 144.899L153.094 146.268L151.372 147.216V147.43H157.609Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M137.687 79.1L136.266 78.2775C136.266 78.2775 135.713 78.211 135.951 78.827L137.372 79.9225",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M137.687 79.1L136.266 78.2775C136.266 78.2775 135.713 78.211 135.951 78.827L137.372 79.9225",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M137.477 81.2382C137.41 81.0694 137.311 80.915 137.186 80.7832L136.92 80.4962L135.475 78.7042C135.475 78.7042 135.027 78.4032 135.125 79.0542L136.021 80.8042L134.428 79.3097C134.428 79.3097 134.127 79.0612 134.127 79.4112C134.127 79.7612 135.573 81.3047 135.573 81.3047L133.977 80.5557C133.977 80.5557 133.627 80.8042 133.879 81.0527C134.131 81.3012 135.471 81.8017 135.471 81.8017L134.278 81.7527C134.278 81.7527 133.928 82.0502 134.176 82.1517C134.425 82.2532 135.821 82.5472 135.821 82.5472C135.998 82.6981 136.201 82.8165 136.42 82.8972L136.77 83.5447L138.11 82.8692L137.477 81.2382Z",
    fill: "white",
    stroke: "#0D3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M151.788 96.775L143.801 98.6475C143.392 98.7195 142.971 98.6476 142.609 98.444C142.247 98.2405 141.967 97.9178 141.816 97.531L136.776 83.531L138.117 82.8555L143.685 93.17C143.812 93.4059 144.011 93.5949 144.253 93.709C144.495 93.8231 144.767 93.8562 145.029 93.8035L151.137 92.078",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M151.788 96.775L143.801 98.6475C143.392 98.7195 142.971 98.6476 142.609 98.444C142.247 98.2405 141.967 97.9178 141.816 97.531L136.776 83.531L138.117 82.8555L143.685 93.17C143.812 93.4059 144.011 93.5949 144.253 93.709C144.495 93.8231 144.767 93.8562 145.029 93.8035L151.137 92.078",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M138.869 84.1748L137.315 84.9518",
    stroke: "#0D3744",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M150.794 81.7599C150.794 81.7599 149.944 82.6104 150.367 83.2474C150.618 83.6153 150.809 84.0205 150.934 84.4479C150.934 84.4479 150.584 85.2984 150.864 85.2984C151.144 85.2984 151.004 84.6614 151.501 84.8049C151.998 84.9484 152.492 85.7954 152.068 86.0789C151.751 86.256 151.415 86.3969 151.067 86.4989C151.023 86.5125 150.983 86.5387 150.954 86.5744C150.924 86.6101 150.905 86.6537 150.9 86.6998C150.895 86.746 150.903 86.7926 150.924 86.834C150.945 86.8754 150.978 86.9098 151.018 86.9329C151.478 87.244 152.009 87.4363 152.562 87.4929C153.014 87.5026 153.465 87.4556 153.906 87.3529C153.906 87.3529 155.306 85.4419 156.314 84.9449C157.322 84.4479 156.881 82.1834 156.881 81.8999C156.881 81.6164 155.89 80.9794 155.89 80.9794C155.89 80.9794 156.174 80.3424 154.9 78.9284C153.626 77.5144 151.218 77.2274 151.148 77.7244C151.123 77.856 151.137 77.9919 151.187 78.1159C151.237 78.24 151.322 78.3471 151.431 78.4244C151.431 78.4244 149.307 77.5039 148.316 78.4944C147.326 79.4849 150.794 81.7599 150.794 81.7599Z",
    fill: "#0D3744",
    stroke: "#0D3744",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M150.794 81.7598C150.794 81.7598 152.516 83.8598 155.068 84.0628",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M150.185 82.4004C150.185 82.4004 150.986 84.7314 154.301 85.3964",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsFaq);
export default __webpack_public_path__ + "static/media/DocumentsFAQ.31ea8f1d4ca0c55ec0f71b6bdcdc45b2.svg";
export { ForwardRef as ReactComponent };